module.exports = __webpack_public_path__ + "media/stitched-wpa.ae5ec94a.mp4";